var Ft = Object.defineProperty;
var De = Object.getOwnPropertySymbols;
var Nt = Object.prototype.hasOwnProperty, Pt = Object.prototype.propertyIsEnumerable;
var Ie = (e, t, r) => t in e ? Ft(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, ae = (e, t) => {
  for (var r in t || (t = {}))
    Nt.call(t, r) && Ie(e, r, t[r]);
  if (De)
    for (var r of De(t))
      Pt.call(t, r) && Ie(e, r, t[r]);
  return e;
};
var $ = (e, t, r) => new Promise((n, o) => {
  var s = (E) => {
    try {
      f(r.next(E));
    } catch (a) {
      o(a);
    }
  }, i = (E) => {
    try {
      f(r.throw(E));
    } catch (a) {
      o(a);
    }
  }, f = (E) => E.done ? n(E.value) : Promise.resolve(E.value).then(s, i);
  f((r = r.apply(e, t)).next());
});
function kt() {
  return null;
}
const k = {
  logError(...e) {
    console && console.error && console.error(...e);
  },
  logWarn(...e) {
    console && console.warn && console.warn(...e);
  },
  logInfo(...e) {
    console && console.info && console.info(...e);
  }
};
function Lt(e) {
  Object.assign(k, e);
}
var nt = /* @__PURE__ */ ((e) => (e.And = "and", e.Or = "or", e.Eq = "eq", e.Neq = "neq", e.In = "in", e.Nin = "nin", e.Gt = "gt", e.Gte = "gte", e.Lt = "lt", e.Lte = "lte", e))(nt || {});
function Ut(e) {
  const t = Object.values(nt).filter((r) => typeof e[r] != "undefined");
  if (t.length > 1)
    throw new Error(`Multiple operators specified (${t.join(", ")})`);
}
function ot(e, t) {
  const { property: r } = e;
  if (!t.size)
    throw new Error("No restriction properties found");
  if (!t.has(r))
    throw new Error(`Unexpected restriction property: ${r}`);
  const n = t.get(r);
  if (typeof n == "function")
    return n();
  throw new Error("No restriction properties found");
}
function K(e, t, r) {
  const n = ot(t, r.restrictionsProviders);
  return e.toLowerCase() === (n == null ? void 0 : n.toLowerCase());
}
const Dt = (e, t) => e.localeCompare(t, void 0, {
  ignorePunctuation: !0,
  numeric: !0,
  sensitivity: "base"
});
function je(e, t, { property: r }) {
  if (r === "AppVersion")
    return Dt(e, t) === 1;
  throw new Error(`Property is not comparable: ${r}`);
}
function ue(e, t, r) {
  const n = ot(t, r.restrictionsProviders), o = t[e], s = K(o, t, r);
  return [
    "eq",
    "gte",
    "lte"
    /* Lte */
  ].includes(e) && s ? !0 : [
    "gt",
    "gte"
    /* Gte */
  ].includes(e) ? je(n, o, t) : [
    "lt",
    "lte"
    /* Lte */
  ].includes(e) ? je(o, n, t) : !1;
}
function de(e, t) {
  try {
    return Ut(e), e.and ? e.and.every((r) => de(r, t)) : e.or ? e.or.some((r) => de(r, t)) : e.eq ? K(e.eq, e, t) : e.neq ? !K(e.neq, e, t) : e.in ? e.in.some((r) => K(r, e, t)) : e.nin ? e.nin.every((r) => !K(r, e, t)) : e.gt ? ue("gt", e, t) : e.gte ? ue("gte", e, t) : e.lt ? ue("lt", e, t) : e.lte ? ue("lte", e, t) : !0;
  } catch (r) {
    const n = r instanceof Error ? r.message : "Unknown error";
    return k.logWarn(n, null, { error: r }), !1;
  }
}
var G = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function st(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function It(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var o = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var it = { exports: {} };
function jt(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var be = { exports: {} };
const Ht = {}, Vt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ht
}, Symbol.toStringTag, { value: "Module" })), $t = /* @__PURE__ */ It(Vt);
var He;
function at() {
  return He || (He = 1, function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(G, function() {
      var r = r || function(n, o) {
        var s;
        if (typeof window != "undefined" && window.crypto && (s = window.crypto), typeof self != "undefined" && self.crypto && (s = self.crypto), typeof globalThis != "undefined" && globalThis.crypto && (s = globalThis.crypto), !s && typeof window != "undefined" && window.msCrypto && (s = window.msCrypto), !s && typeof G != "undefined" && G.crypto && (s = G.crypto), !s && typeof jt == "function")
          try {
            s = $t;
          } catch (l) {
          }
        var i = function() {
          if (s) {
            if (typeof s.getRandomValues == "function")
              try {
                return s.getRandomValues(new Uint32Array(1))[0];
              } catch (l) {
              }
            if (typeof s.randomBytes == "function")
              try {
                return s.randomBytes(4).readInt32LE();
              } catch (l) {
              }
          }
          throw new Error("Native crypto module could not be used to get secure random number.");
        }, f = Object.create || function() {
          function l() {
          }
          return function(g) {
            var v;
            return l.prototype = g, v = new l(), l.prototype = null, v;
          };
        }(), E = {}, a = E.lib = {}, b = a.Base = function() {
          return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function(l) {
              var g = f(this);
              return l && g.mixIn(l), (!g.hasOwnProperty("init") || this.init === g.init) && (g.init = function() {
                g.$super.init.apply(this, arguments);
              }), g.init.prototype = g, g.$super = this, g;
            },
            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function() {
              var l = this.extend();
              return l.init.apply(l, arguments), l;
            },
            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function() {
            },
            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function(l) {
              for (var g in l)
                l.hasOwnProperty(g) && (this[g] = l[g]);
              l.hasOwnProperty("toString") && (this.toString = l.toString);
            },
            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function() {
              return this.init.prototype.extend(this);
            }
          };
        }(), c = a.WordArray = b.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of 32-bit words.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.create();
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
           */
          init: function(l, g) {
            l = this.words = l || [], g != o ? this.sigBytes = g : this.sigBytes = l.length * 4;
          },
          /**
           * Converts this word array to a string.
           *
           * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
           *
           * @return {string} The stringified word array.
           *
           * @example
           *
           *     var string = wordArray + '';
           *     var string = wordArray.toString();
           *     var string = wordArray.toString(CryptoJS.enc.Utf8);
           */
          toString: function(l) {
            return (l || T).stringify(this);
          },
          /**
           * Concatenates a word array to this word array.
           *
           * @param {WordArray} wordArray The word array to append.
           *
           * @return {WordArray} This word array.
           *
           * @example
           *
           *     wordArray1.concat(wordArray2);
           */
          concat: function(l) {
            var g = this.words, v = l.words, R = this.sigBytes, A = l.sigBytes;
            if (this.clamp(), R % 4)
              for (var _ = 0; _ < A; _++) {
                var N = v[_ >>> 2] >>> 24 - _ % 4 * 8 & 255;
                g[R + _ >>> 2] |= N << 24 - (R + _) % 4 * 8;
              }
            else
              for (var F = 0; F < A; F += 4)
                g[R + F >>> 2] = v[F >>> 2];
            return this.sigBytes += A, this;
          },
          /**
           * Removes insignificant bits.
           *
           * @example
           *
           *     wordArray.clamp();
           */
          clamp: function() {
            var l = this.words, g = this.sigBytes;
            l[g >>> 2] &= 4294967295 << 32 - g % 4 * 8, l.length = n.ceil(g / 4);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {WordArray} The clone.
           *
           * @example
           *
           *     var clone = wordArray.clone();
           */
          clone: function() {
            var l = b.clone.call(this);
            return l.words = this.words.slice(0), l;
          },
          /**
           * Creates a word array filled with random bytes.
           *
           * @param {number} nBytes The number of random bytes to generate.
           *
           * @return {WordArray} The random word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.random(16);
           */
          random: function(l) {
            for (var g = [], v = 0; v < l; v += 4)
              g.push(i());
            return new c.init(g, l);
          }
        }), O = E.enc = {}, T = O.Hex = {
          /**
           * Converts a word array to a hex string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The hex string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
           */
          stringify: function(l) {
            for (var g = l.words, v = l.sigBytes, R = [], A = 0; A < v; A++) {
              var _ = g[A >>> 2] >>> 24 - A % 4 * 8 & 255;
              R.push((_ >>> 4).toString(16)), R.push((_ & 15).toString(16));
            }
            return R.join("");
          },
          /**
           * Converts a hex string to a word array.
           *
           * @param {string} hexStr The hex string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
           */
          parse: function(l) {
            for (var g = l.length, v = [], R = 0; R < g; R += 2)
              v[R >>> 3] |= parseInt(l.substr(R, 2), 16) << 24 - R % 8 * 4;
            return new c.init(v, g / 2);
          }
        }, w = O.Latin1 = {
          /**
           * Converts a word array to a Latin1 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Latin1 string.
           *
           * @static
           *
           * @example
           *
           *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
           */
          stringify: function(l) {
            for (var g = l.words, v = l.sigBytes, R = [], A = 0; A < v; A++) {
              var _ = g[A >>> 2] >>> 24 - A % 4 * 8 & 255;
              R.push(String.fromCharCode(_));
            }
            return R.join("");
          },
          /**
           * Converts a Latin1 string to a word array.
           *
           * @param {string} latin1Str The Latin1 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
           */
          parse: function(l) {
            for (var g = l.length, v = [], R = 0; R < g; R++)
              v[R >>> 2] |= (l.charCodeAt(R) & 255) << 24 - R % 4 * 8;
            return new c.init(v, g);
          }
        }, d = O.Utf8 = {
          /**
           * Converts a word array to a UTF-8 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-8 string.
           *
           * @static
           *
           * @example
           *
           *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
           */
          stringify: function(l) {
            try {
              return decodeURIComponent(escape(w.stringify(l)));
            } catch (g) {
              throw new Error("Malformed UTF-8 data");
            }
          },
          /**
           * Converts a UTF-8 string to a word array.
           *
           * @param {string} utf8Str The UTF-8 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
           */
          parse: function(l) {
            return w.parse(unescape(encodeURIComponent(l)));
          }
        }, S = a.BufferedBlockAlgorithm = b.extend({
          /**
           * Resets this block algorithm's data buffer to its initial state.
           *
           * @example
           *
           *     bufferedBlockAlgorithm.reset();
           */
          reset: function() {
            this._data = new c.init(), this._nDataBytes = 0;
          },
          /**
           * Adds new data to this block algorithm's buffer.
           *
           * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
           *
           * @example
           *
           *     bufferedBlockAlgorithm._append('data');
           *     bufferedBlockAlgorithm._append(wordArray);
           */
          _append: function(l) {
            typeof l == "string" && (l = d.parse(l)), this._data.concat(l), this._nDataBytes += l.sigBytes;
          },
          /**
           * Processes available data blocks.
           *
           * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
           *
           * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
           *
           * @return {WordArray} The processed data.
           *
           * @example
           *
           *     var processedData = bufferedBlockAlgorithm._process();
           *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
           */
          _process: function(l) {
            var g, v = this._data, R = v.words, A = v.sigBytes, _ = this.blockSize, N = _ * 4, F = A / N;
            l ? F = n.ceil(F) : F = n.max((F | 0) - this._minBufferSize, 0);
            var D = F * _, V = n.min(D * 4, A);
            if (D) {
              for (var j = 0; j < D; j += _)
                this._doProcessBlock(R, j);
              g = R.splice(0, D), v.sigBytes -= V;
            }
            return new c.init(g, V);
          },
          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = bufferedBlockAlgorithm.clone();
           */
          clone: function() {
            var l = b.clone.call(this);
            return l._data = this._data.clone(), l;
          },
          _minBufferSize: 0
        });
        a.Hasher = S.extend({
          /**
           * Configuration options.
           */
          cfg: b.extend(),
          /**
           * Initializes a newly created hasher.
           *
           * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
           *
           * @example
           *
           *     var hasher = CryptoJS.algo.SHA256.create();
           */
          init: function(l) {
            this.cfg = this.cfg.extend(l), this.reset();
          },
          /**
           * Resets this hasher to its initial state.
           *
           * @example
           *
           *     hasher.reset();
           */
          reset: function() {
            S.reset.call(this), this._doReset();
          },
          /**
           * Updates this hasher with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {Hasher} This hasher.
           *
           * @example
           *
           *     hasher.update('message');
           *     hasher.update(wordArray);
           */
          update: function(l) {
            return this._append(l), this._process(), this;
          },
          /**
           * Finalizes the hash computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The hash.
           *
           * @example
           *
           *     var hash = hasher.finalize();
           *     var hash = hasher.finalize('message');
           *     var hash = hasher.finalize(wordArray);
           */
          finalize: function(l) {
            l && this._append(l);
            var g = this._doFinalize();
            return g;
          },
          blockSize: 16,
          /**
           * Creates a shortcut function to a hasher's object interface.
           *
           * @param {Hasher} hasher The hasher to create a helper for.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
           */
          _createHelper: function(l) {
            return function(g, v) {
              return new l.init(v).finalize(g);
            };
          },
          /**
           * Creates a shortcut function to the HMAC's object interface.
           *
           * @param {Hasher} hasher The hasher to use in this HMAC helper.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
           */
          _createHmacHelper: function(l) {
            return function(g, v) {
              return new C.HMAC.init(l, v).finalize(g);
            };
          }
        });
        var C = E.algo = {};
        return E;
      }(Math);
      return r;
    });
  }(be)), be.exports;
}
(function(e, t) {
  (function(r, n) {
    e.exports = n(at());
  })(G, function(r) {
    return function(n) {
      var o = r, s = o.lib, i = s.WordArray, f = s.Hasher, E = o.algo, a = [];
      (function() {
        for (var d = 0; d < 64; d++)
          a[d] = n.abs(n.sin(d + 1)) * 4294967296 | 0;
      })();
      var b = E.MD5 = f.extend({
        _doReset: function() {
          this._hash = new i.init([
            1732584193,
            4023233417,
            2562383102,
            271733878
          ]);
        },
        _doProcessBlock: function(d, S) {
          for (var C = 0; C < 16; C++) {
            var l = S + C, g = d[l];
            d[l] = (g << 8 | g >>> 24) & 16711935 | (g << 24 | g >>> 8) & 4278255360;
          }
          var v = this._hash.words, R = d[S + 0], A = d[S + 1], _ = d[S + 2], N = d[S + 3], F = d[S + 4], D = d[S + 5], V = d[S + 6], j = d[S + 7], Y = d[S + 8], ee = d[S + 9], te = d[S + 10], re = d[S + 11], ne = d[S + 12], oe = d[S + 13], se = d[S + 14], ie = d[S + 15], h = v[0], p = v[1], m = v[2], y = v[3];
          h = c(h, p, m, y, R, 7, a[0]), y = c(y, h, p, m, A, 12, a[1]), m = c(m, y, h, p, _, 17, a[2]), p = c(p, m, y, h, N, 22, a[3]), h = c(h, p, m, y, F, 7, a[4]), y = c(y, h, p, m, D, 12, a[5]), m = c(m, y, h, p, V, 17, a[6]), p = c(p, m, y, h, j, 22, a[7]), h = c(h, p, m, y, Y, 7, a[8]), y = c(y, h, p, m, ee, 12, a[9]), m = c(m, y, h, p, te, 17, a[10]), p = c(p, m, y, h, re, 22, a[11]), h = c(h, p, m, y, ne, 7, a[12]), y = c(y, h, p, m, oe, 12, a[13]), m = c(m, y, h, p, se, 17, a[14]), p = c(p, m, y, h, ie, 22, a[15]), h = O(h, p, m, y, A, 5, a[16]), y = O(y, h, p, m, V, 9, a[17]), m = O(m, y, h, p, re, 14, a[18]), p = O(p, m, y, h, R, 20, a[19]), h = O(h, p, m, y, D, 5, a[20]), y = O(y, h, p, m, te, 9, a[21]), m = O(m, y, h, p, ie, 14, a[22]), p = O(p, m, y, h, F, 20, a[23]), h = O(h, p, m, y, ee, 5, a[24]), y = O(y, h, p, m, se, 9, a[25]), m = O(m, y, h, p, N, 14, a[26]), p = O(p, m, y, h, Y, 20, a[27]), h = O(h, p, m, y, oe, 5, a[28]), y = O(y, h, p, m, _, 9, a[29]), m = O(m, y, h, p, j, 14, a[30]), p = O(p, m, y, h, ne, 20, a[31]), h = T(h, p, m, y, D, 4, a[32]), y = T(y, h, p, m, Y, 11, a[33]), m = T(m, y, h, p, re, 16, a[34]), p = T(p, m, y, h, se, 23, a[35]), h = T(h, p, m, y, A, 4, a[36]), y = T(y, h, p, m, F, 11, a[37]), m = T(m, y, h, p, j, 16, a[38]), p = T(p, m, y, h, te, 23, a[39]), h = T(h, p, m, y, oe, 4, a[40]), y = T(y, h, p, m, R, 11, a[41]), m = T(m, y, h, p, N, 16, a[42]), p = T(p, m, y, h, V, 23, a[43]), h = T(h, p, m, y, ee, 4, a[44]), y = T(y, h, p, m, ne, 11, a[45]), m = T(m, y, h, p, ie, 16, a[46]), p = T(p, m, y, h, _, 23, a[47]), h = w(h, p, m, y, R, 6, a[48]), y = w(y, h, p, m, j, 10, a[49]), m = w(m, y, h, p, se, 15, a[50]), p = w(p, m, y, h, D, 21, a[51]), h = w(h, p, m, y, ne, 6, a[52]), y = w(y, h, p, m, N, 10, a[53]), m = w(m, y, h, p, te, 15, a[54]), p = w(p, m, y, h, A, 21, a[55]), h = w(h, p, m, y, Y, 6, a[56]), y = w(y, h, p, m, ie, 10, a[57]), m = w(m, y, h, p, V, 15, a[58]), p = w(p, m, y, h, oe, 21, a[59]), h = w(h, p, m, y, F, 6, a[60]), y = w(y, h, p, m, re, 10, a[61]), m = w(m, y, h, p, _, 15, a[62]), p = w(p, m, y, h, ee, 21, a[63]), v[0] = v[0] + h | 0, v[1] = v[1] + p | 0, v[2] = v[2] + m | 0, v[3] = v[3] + y | 0;
        },
        _doFinalize: function() {
          var d = this._data, S = d.words, C = this._nDataBytes * 8, l = d.sigBytes * 8;
          S[l >>> 5] |= 128 << 24 - l % 32;
          var g = n.floor(C / 4294967296), v = C;
          S[(l + 64 >>> 9 << 4) + 15] = (g << 8 | g >>> 24) & 16711935 | (g << 24 | g >>> 8) & 4278255360, S[(l + 64 >>> 9 << 4) + 14] = (v << 8 | v >>> 24) & 16711935 | (v << 24 | v >>> 8) & 4278255360, d.sigBytes = (S.length + 1) * 4, this._process();
          for (var R = this._hash, A = R.words, _ = 0; _ < 4; _++) {
            var N = A[_];
            A[_] = (N << 8 | N >>> 24) & 16711935 | (N << 24 | N >>> 8) & 4278255360;
          }
          return R;
        },
        clone: function() {
          var d = f.clone.call(this);
          return d._hash = this._hash.clone(), d;
        }
      });
      function c(d, S, C, l, g, v, R) {
        var A = d + (S & C | ~S & l) + g + R;
        return (A << v | A >>> 32 - v) + S;
      }
      function O(d, S, C, l, g, v, R) {
        var A = d + (S & l | C & ~l) + g + R;
        return (A << v | A >>> 32 - v) + S;
      }
      function T(d, S, C, l, g, v, R) {
        var A = d + (S ^ C ^ l) + g + R;
        return (A << v | A >>> 32 - v) + S;
      }
      function w(d, S, C, l, g, v, R) {
        var A = d + (C ^ (S | ~l)) + g + R;
        return (A << v | A >>> 32 - v) + S;
      }
      o.MD5 = f._createHelper(b), o.HmacMD5 = f._createHmacHelper(b);
    }(Math), r.MD5;
  });
})(it);
var qt = it.exports;
const Mt = /* @__PURE__ */ st(qt);
var zt = at();
const ut = /* @__PURE__ */ st(zt);
function Wt(e) {
  const t = [];
  for (let r = 0; r < e.length; r++)
    t[r / 4 | 0] |= e[r] << 24 - 8 * r;
  return ut.lib.WordArray.create(t, e.length);
}
function Jt(e, t) {
  const r = [];
  return t > 0 && r.push(e >>> 24), t > 1 && r.push(e >>> 16 & 255), t > 2 && r.push(e >>> 8 & 255), t > 3 && r.push(e & 255), r;
}
function ct(e, t) {
  let r = e, n = t;
  Object.prototype.hasOwnProperty.call(r, "sigBytes") && Object.prototype.hasOwnProperty.call(r, "words") && (n = r.sigBytes, r = r.words);
  const o = [];
  let s, i = 0;
  for (; n > 0; )
    s = Jt(r[i], Math.min(4, n)), n -= s.length, o.push(s), i++;
  return [].concat.apply([], o);
}
function Ve(e) {
  const t = Mt(e), r = ct(t);
  return ((r[1] << 8) + r[0]) / 65535;
}
function Kt(e) {
  const t = ut.enc.Utf8.parse(e), r = Ve(t), n = ct(t);
  n[0] ^= 1;
  const o = Wt(n), s = Ve(o);
  return { audienceFraction: r, variantFraction: s };
}
var _e = /* @__PURE__ */ ((e) => (e.Disabled = "disabled", e))(_e || {});
const Gt = (e) => e.sort((t, r) => r.weight - t.weight);
function Xt(e, t) {
  return e.rules.find((r) => de(r.restrictions, t)) || null;
}
function Qt(e, t) {
  if (e.bucketBy === "AnonUserId")
    return t.anonUserId;
  throw new Error("Unexpected bucketBy ", e.bucketBy);
}
const Zt = (e) => +e.weight.toFixed(1) === 1 ? e : null;
function Yt(e, t) {
  if (t > 1)
    throw new Error(`Variant fraction must not be > 1, was ${t}.`);
  const r = e.variants.reduce((s, i) => s + i.weight, 0);
  let n = 0;
  const o = e.variants.find((s) => (n += s.weight / r, n >= t));
  if (!o)
    throw new Error("No matching variant found.");
  return o;
}
function er(e, t) {
  const r = Xt(e, t);
  if (!r)
    return null;
  if (t.mode && t.mode() === _e.Disabled)
    if (r.variants) {
      const i = Gt(r.variants);
      return Zt(i[0]);
    } else
      return null;
  if (r.audienceFraction === 0)
    return null;
  const n = e.prefix + Qt(e, t), { audienceFraction: o, variantFraction: s } = Kt(n);
  return r.audienceFraction < o ? null : Yt(r, s);
}
const tr = (e, t) => {
  if (!e.evaluationLogic)
    return null;
  try {
    const { type: r } = e.evaluationLogic;
    if (r === "IdHash")
      return er(e.evaluationLogic.detail, t);
  } catch (r) {
    const n = r instanceof Error ? r.message : "Unknown error";
    k.logError(n, { error: r });
  }
  return null;
}, rr = (e, t) => {
  const r = e.defaultValueRules.find(
    (n) => de(n.restrictions, t)
  );
  return r ? r.value : null;
}, nr = (e, t) => {
  try {
    const { experimentKey: r, experimentVariant: n } = e;
    if (!r || !n)
      return;
    if (!t) {
      k.logWarn(
        `Experiment will not be tracked as no \`onTrack\` callback was provided (key: ${r}, variant: ${n})`
      );
      return;
    }
    k.logInfo(`Tracking experiment - key: ${r}, variant: ${n}`), t(r, n);
  } catch (r) {
    k.logError("An exception occurred while trying to send an experiment event", { error: r });
  }
};
class or {
  constructor(t) {
    this.fm = t;
  }
  peekExperiments() {
    const t = [];
    return Object.keys(this.fm.featureLookup.getFeatureKeys()).sort().forEach((r) => {
      const n = r.replace(`${this.fm.settings.keyPrefix}::`, "");
      t.push({ key: r, value: this.fm.getValue(n, [], !1) });
    }), t;
  }
}
var M = /* @__PURE__ */ ((e) => (e.Bool = "bool", e.Int = "int", e.String = "string", e))(M || {});
class sr {
  constructor(t) {
    try {
      this.url = new URL(t);
    } catch (r) {
      k.logWarn(
        `[FeatureOverride] Invalid URL string '${t}'. Check your settings for the plugin`,
        { error: r }
      );
    }
  }
  getOverride(t, r) {
    if (!this.url)
      return null;
    const o = this.url.searchParams.get(`jet-fm-${t}`);
    if (!o)
      return null;
    r || (r = this.determineType(o));
    try {
      let s = o;
      return r === M.Bool && (s = this.stringToBoolean(o)), r === M.Int && (s = this.stringToNumber(o)), console.log(`[FeatureOverride] The Feature '${t}' has been overridden with '${s}'.`), s;
    } catch (s) {
      const i = s instanceof Error ? s.message : "Unknown error";
      return console.log(
        `[FeatureOverride] The Feature '${t}' has an override value '${o}' but cannot be casted to '${r}'. [${i}]`
      ), null;
    }
  }
  determineType(t) {
    return t.toLowerCase() === "true" || t.toLowerCase() === "false" ? M.Bool : Number.isInteger(Number(t)) ? M.Int : M.String;
  }
  stringToBoolean(t) {
    if (t.toLowerCase() === "true")
      return !0;
    if (t.toLowerCase() === "false")
      return !1;
    throw new Error("Cast error: Not a boolean");
  }
  stringToNumber(t) {
    const r = Number(t);
    if (isNaN(r))
      throw new Error("Cast error: Not a number");
    return r;
  }
}
function lt(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: ir } = Object.prototype, { getPrototypeOf: Be } = Object, pe = ((e) => (t) => {
  const r = ir.call(t);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), U = (e) => (e = e.toLowerCase(), (t) => pe(t) === e), me = (e) => (t) => typeof t === e, { isArray: W } = Array, X = me("undefined");
function ar(e) {
  return e !== null && !X(e) && e.constructor !== null && !X(e.constructor) && P(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const ft = U("ArrayBuffer");
function ur(e) {
  let t;
  return typeof ArrayBuffer != "undefined" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && ft(e.buffer), t;
}
const cr = me("string"), P = me("function"), dt = me("number"), ye = (e) => e !== null && typeof e == "object", lr = (e) => e === !0 || e === !1, ce = (e) => {
  if (pe(e) !== "object")
    return !1;
  const t = Be(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, fr = U("Date"), dr = U("File"), hr = U("Blob"), pr = U("FileList"), mr = (e) => ye(e) && P(e.pipe), yr = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || P(e.append) && ((t = pe(e)) === "formdata" || // detect form-data instance
  t === "object" && P(e.toString) && e.toString() === "[object FormData]"));
}, gr = U("URLSearchParams"), wr = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Q(e, t, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e == "undefined")
    return;
  let n, o;
  if (typeof e != "object" && (e = [e]), W(e))
    for (n = 0, o = e.length; n < o; n++)
      t.call(null, e[n], n, e);
  else {
    const s = r ? Object.getOwnPropertyNames(e) : Object.keys(e), i = s.length;
    let f;
    for (n = 0; n < i; n++)
      f = s[n], t.call(null, e[f], f, e);
  }
}
function ht(e, t) {
  t = t.toLowerCase();
  const r = Object.keys(e);
  let n = r.length, o;
  for (; n-- > 0; )
    if (o = r[n], t === o.toLowerCase())
      return o;
  return null;
}
const pt = (() => typeof globalThis != "undefined" ? globalThis : typeof self != "undefined" ? self : typeof window != "undefined" ? window : global)(), mt = (e) => !X(e) && e !== pt;
function Oe() {
  const { caseless: e } = mt(this) && this || {}, t = {}, r = (n, o) => {
    const s = e && ht(t, o) || o;
    ce(t[s]) && ce(n) ? t[s] = Oe(t[s], n) : ce(n) ? t[s] = Oe({}, n) : W(n) ? t[s] = n.slice() : t[s] = n;
  };
  for (let n = 0, o = arguments.length; n < o; n++)
    arguments[n] && Q(arguments[n], r);
  return t;
}
const br = (e, t, r, { allOwnKeys: n } = {}) => (Q(t, (o, s) => {
  r && P(o) ? e[s] = lt(o, r) : e[s] = o;
}, { allOwnKeys: n }), e), Er = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), vr = (e, t, r, n) => {
  e.prototype = Object.create(t.prototype, n), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), r && Object.assign(e.prototype, r);
}, Sr = (e, t, r, n) => {
  let o, s, i;
  const f = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (o = Object.getOwnPropertyNames(e), s = o.length; s-- > 0; )
      i = o[s], (!n || n(i, e, t)) && !f[i] && (t[i] = e[i], f[i] = !0);
    e = r !== !1 && Be(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}, Rr = (e, t, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  const n = e.indexOf(t, r);
  return n !== -1 && n === r;
}, Or = (e) => {
  if (!e)
    return null;
  if (W(e))
    return e;
  let t = e.length;
  if (!dt(t))
    return null;
  const r = new Array(t);
  for (; t-- > 0; )
    r[t] = e[t];
  return r;
}, Ar = ((e) => (t) => e && t instanceof e)(typeof Uint8Array != "undefined" && Be(Uint8Array)), xr = (e, t) => {
  const n = (e && e[Symbol.iterator]).call(e);
  let o;
  for (; (o = n.next()) && !o.done; ) {
    const s = o.value;
    t.call(e, s[0], s[1]);
  }
}, Cr = (e, t) => {
  let r;
  const n = [];
  for (; (r = e.exec(t)) !== null; )
    n.push(r);
  return n;
}, Tr = U("HTMLFormElement"), _r = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, n, o) {
    return n.toUpperCase() + o;
  }
), $e = (({ hasOwnProperty: e }) => (t, r) => e.call(t, r))(Object.prototype), Br = U("RegExp"), yt = (e, t) => {
  const r = Object.getOwnPropertyDescriptors(e), n = {};
  Q(r, (o, s) => {
    let i;
    (i = t(o, s, e)) !== !1 && (n[s] = i || o);
  }), Object.defineProperties(e, n);
}, Fr = (e) => {
  yt(e, (t, r) => {
    if (P(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const n = e[r];
    if (P(n)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, Nr = (e, t) => {
  const r = {}, n = (o) => {
    o.forEach((s) => {
      r[s] = !0;
    });
  };
  return W(e) ? n(e) : n(String(e).split(t)), r;
}, Pr = () => {
}, kr = (e, t) => (e = +e, Number.isFinite(e) ? e : t), Ee = "abcdefghijklmnopqrstuvwxyz", qe = "0123456789", gt = {
  DIGIT: qe,
  ALPHA: Ee,
  ALPHA_DIGIT: Ee + Ee.toUpperCase() + qe
}, Lr = (e = 16, t = gt.ALPHA_DIGIT) => {
  let r = "";
  const { length: n } = t;
  for (; e--; )
    r += t[Math.random() * n | 0];
  return r;
};
function Ur(e) {
  return !!(e && P(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const Dr = (e) => {
  const t = new Array(10), r = (n, o) => {
    if (ye(n)) {
      if (t.indexOf(n) >= 0)
        return;
      if (!("toJSON" in n)) {
        t[o] = n;
        const s = W(n) ? [] : {};
        return Q(n, (i, f) => {
          const E = r(i, o + 1);
          !X(E) && (s[f] = E);
        }), t[o] = void 0, s;
      }
    }
    return n;
  };
  return r(e, 0);
}, Ir = U("AsyncFunction"), jr = (e) => e && (ye(e) || P(e)) && P(e.then) && P(e.catch), u = {
  isArray: W,
  isArrayBuffer: ft,
  isBuffer: ar,
  isFormData: yr,
  isArrayBufferView: ur,
  isString: cr,
  isNumber: dt,
  isBoolean: lr,
  isObject: ye,
  isPlainObject: ce,
  isUndefined: X,
  isDate: fr,
  isFile: dr,
  isBlob: hr,
  isRegExp: Br,
  isFunction: P,
  isStream: mr,
  isURLSearchParams: gr,
  isTypedArray: Ar,
  isFileList: pr,
  forEach: Q,
  merge: Oe,
  extend: br,
  trim: wr,
  stripBOM: Er,
  inherits: vr,
  toFlatObject: Sr,
  kindOf: pe,
  kindOfTest: U,
  endsWith: Rr,
  toArray: Or,
  forEachEntry: xr,
  matchAll: Cr,
  isHTMLForm: Tr,
  hasOwnProperty: $e,
  hasOwnProp: $e,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: yt,
  freezeMethods: Fr,
  toObjectSet: Nr,
  toCamelCase: _r,
  noop: Pr,
  toFiniteNumber: kr,
  findKey: ht,
  global: pt,
  isContextDefined: mt,
  ALPHABET: gt,
  generateString: Lr,
  isSpecCompliantForm: Ur,
  toJSONObject: Dr,
  isAsyncFn: Ir,
  isThenable: jr
};
function x(e, t, r, n, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), r && (this.config = r), n && (this.request = n), o && (this.response = o);
}
u.inherits(x, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: u.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const wt = x.prototype, bt = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  bt[e] = { value: e };
});
Object.defineProperties(x, bt);
Object.defineProperty(wt, "isAxiosError", { value: !0 });
x.from = (e, t, r, n, o, s) => {
  const i = Object.create(wt);
  return u.toFlatObject(e, i, function(E) {
    return E !== Error.prototype;
  }, (f) => f !== "isAxiosError"), x.call(i, e.message, t, r, n, o), i.cause = e, i.name = e.name, s && Object.assign(i, s), i;
};
const Hr = null;
function Ae(e) {
  return u.isPlainObject(e) || u.isArray(e);
}
function Et(e) {
  return u.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Me(e, t, r) {
  return e ? e.concat(t).map(function(o, s) {
    return o = Et(o), !r && s ? "[" + o + "]" : o;
  }).join(r ? "." : "") : t;
}
function Vr(e) {
  return u.isArray(e) && !e.some(Ae);
}
const $r = u.toFlatObject(u, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function ge(e, t, r) {
  if (!u.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), r = u.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(d, S) {
    return !u.isUndefined(S[d]);
  });
  const n = r.metaTokens, o = r.visitor || b, s = r.dots, i = r.indexes, E = (r.Blob || typeof Blob != "undefined" && Blob) && u.isSpecCompliantForm(t);
  if (!u.isFunction(o))
    throw new TypeError("visitor must be a function");
  function a(w) {
    if (w === null)
      return "";
    if (u.isDate(w))
      return w.toISOString();
    if (!E && u.isBlob(w))
      throw new x("Blob is not supported. Use a Buffer instead.");
    return u.isArrayBuffer(w) || u.isTypedArray(w) ? E && typeof Blob == "function" ? new Blob([w]) : Buffer.from(w) : w;
  }
  function b(w, d, S) {
    let C = w;
    if (w && !S && typeof w == "object") {
      if (u.endsWith(d, "{}"))
        d = n ? d : d.slice(0, -2), w = JSON.stringify(w);
      else if (u.isArray(w) && Vr(w) || (u.isFileList(w) || u.endsWith(d, "[]")) && (C = u.toArray(w)))
        return d = Et(d), C.forEach(function(g, v) {
          !(u.isUndefined(g) || g === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            i === !0 ? Me([d], v, s) : i === null ? d : d + "[]",
            a(g)
          );
        }), !1;
    }
    return Ae(w) ? !0 : (t.append(Me(S, d, s), a(w)), !1);
  }
  const c = [], O = Object.assign($r, {
    defaultVisitor: b,
    convertValue: a,
    isVisitable: Ae
  });
  function T(w, d) {
    if (!u.isUndefined(w)) {
      if (c.indexOf(w) !== -1)
        throw Error("Circular reference detected in " + d.join("."));
      c.push(w), u.forEach(w, function(C, l) {
        (!(u.isUndefined(C) || C === null) && o.call(
          t,
          C,
          u.isString(l) ? l.trim() : l,
          d,
          O
        )) === !0 && T(C, d ? d.concat(l) : [l]);
      }), c.pop();
    }
  }
  if (!u.isObject(e))
    throw new TypeError("data must be an object");
  return T(e), t;
}
function ze(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function Fe(e, t) {
  this._pairs = [], e && ge(e, this, t);
}
const vt = Fe.prototype;
vt.append = function(t, r) {
  this._pairs.push([t, r]);
};
vt.toString = function(t) {
  const r = t ? function(n) {
    return t.call(this, n, ze);
  } : ze;
  return this._pairs.map(function(o) {
    return r(o[0]) + "=" + r(o[1]);
  }, "").join("&");
};
function qr(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function St(e, t, r) {
  if (!t)
    return e;
  const n = r && r.encode || qr, o = r && r.serialize;
  let s;
  if (o ? s = o(t, r) : s = u.isURLSearchParams(t) ? t.toString() : new Fe(t, r).toString(n), s) {
    const i = e.indexOf("#");
    i !== -1 && (e = e.slice(0, i)), e += (e.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return e;
}
class Mr {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, r, n) {
    return this.handlers.push({
      fulfilled: t,
      rejected: r,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    u.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
}
const We = Mr, Rt = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, zr = typeof URLSearchParams != "undefined" ? URLSearchParams : Fe, Wr = typeof FormData != "undefined" ? FormData : null, Jr = typeof Blob != "undefined" ? Blob : null, Kr = {
  isBrowser: !0,
  classes: {
    URLSearchParams: zr,
    FormData: Wr,
    Blob: Jr
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Ot = typeof window != "undefined" && typeof document != "undefined", Gr = ((e) => Ot && ["ReactNative", "NativeScript", "NS"].indexOf(e) < 0)(typeof navigator != "undefined" && navigator.product), Xr = (() => typeof WorkerGlobalScope != "undefined" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), Qr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Ot,
  hasStandardBrowserEnv: Gr,
  hasStandardBrowserWebWorkerEnv: Xr
}, Symbol.toStringTag, { value: "Module" })), L = ae(ae({}, Qr), Kr);
function Zr(e, t) {
  return ge(e, new L.classes.URLSearchParams(), Object.assign({
    visitor: function(r, n, o, s) {
      return L.isNode && u.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : s.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function Yr(e) {
  return u.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function en(e) {
  const t = {}, r = Object.keys(e);
  let n;
  const o = r.length;
  let s;
  for (n = 0; n < o; n++)
    s = r[n], t[s] = e[s];
  return t;
}
function At(e) {
  function t(r, n, o, s) {
    let i = r[s++];
    if (i === "__proto__")
      return !0;
    const f = Number.isFinite(+i), E = s >= r.length;
    return i = !i && u.isArray(o) ? o.length : i, E ? (u.hasOwnProp(o, i) ? o[i] = [o[i], n] : o[i] = n, !f) : ((!o[i] || !u.isObject(o[i])) && (o[i] = []), t(r, n, o[i], s) && u.isArray(o[i]) && (o[i] = en(o[i])), !f);
  }
  if (u.isFormData(e) && u.isFunction(e.entries)) {
    const r = {};
    return u.forEachEntry(e, (n, o) => {
      t(Yr(n), o, r, 0);
    }), r;
  }
  return null;
}
function tn(e, t, r) {
  if (u.isString(e))
    try {
      return (t || JSON.parse)(e), u.trim(e);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (r || JSON.stringify)(e);
}
const Ne = {
  transitional: Rt,
  adapter: ["xhr", "http"],
  transformRequest: [function(t, r) {
    const n = r.getContentType() || "", o = n.indexOf("application/json") > -1, s = u.isObject(t);
    if (s && u.isHTMLForm(t) && (t = new FormData(t)), u.isFormData(t))
      return o ? JSON.stringify(At(t)) : t;
    if (u.isArrayBuffer(t) || u.isBuffer(t) || u.isStream(t) || u.isFile(t) || u.isBlob(t))
      return t;
    if (u.isArrayBufferView(t))
      return t.buffer;
    if (u.isURLSearchParams(t))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let f;
    if (s) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return Zr(t, this.formSerializer).toString();
      if ((f = u.isFileList(t)) || n.indexOf("multipart/form-data") > -1) {
        const E = this.env && this.env.FormData;
        return ge(
          f ? { "files[]": t } : t,
          E && new E(),
          this.formSerializer
        );
      }
    }
    return s || o ? (r.setContentType("application/json", !1), tn(t)) : t;
  }],
  transformResponse: [function(t) {
    const r = this.transitional || Ne.transitional, n = r && r.forcedJSONParsing, o = this.responseType === "json";
    if (t && u.isString(t) && (n && !this.responseType || o)) {
      const i = !(r && r.silentJSONParsing) && o;
      try {
        return JSON.parse(t);
      } catch (f) {
        if (i)
          throw f.name === "SyntaxError" ? x.from(f, x.ERR_BAD_RESPONSE, this, null, this.response) : f;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: L.classes.FormData,
    Blob: L.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
u.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  Ne.headers[e] = {};
});
const Pe = Ne, rn = u.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), nn = (e) => {
  const t = {};
  let r, n, o;
  return e && e.split(`
`).forEach(function(i) {
    o = i.indexOf(":"), r = i.substring(0, o).trim().toLowerCase(), n = i.substring(o + 1).trim(), !(!r || t[r] && rn[r]) && (r === "set-cookie" ? t[r] ? t[r].push(n) : t[r] = [n] : t[r] = t[r] ? t[r] + ", " + n : n);
  }), t;
}, Je = Symbol("internals");
function J(e) {
  return e && String(e).trim().toLowerCase();
}
function le(e) {
  return e === !1 || e == null ? e : u.isArray(e) ? e.map(le) : String(e);
}
function on(e) {
  const t = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = r.exec(e); )
    t[n[1]] = n[2];
  return t;
}
const sn = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function ve(e, t, r, n, o) {
  if (u.isFunction(n))
    return n.call(this, t, r);
  if (o && (t = r), !!u.isString(t)) {
    if (u.isString(n))
      return t.indexOf(n) !== -1;
    if (u.isRegExp(n))
      return n.test(t);
  }
}
function an(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, r, n) => r.toUpperCase() + n);
}
function un(e, t) {
  const r = u.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(e, n + r, {
      value: function(o, s, i) {
        return this[n].call(this, t, o, s, i);
      },
      configurable: !0
    });
  });
}
class we {
  constructor(t) {
    t && this.set(t);
  }
  set(t, r, n) {
    const o = this;
    function s(f, E, a) {
      const b = J(E);
      if (!b)
        throw new Error("header name must be a non-empty string");
      const c = u.findKey(o, b);
      (!c || o[c] === void 0 || a === !0 || a === void 0 && o[c] !== !1) && (o[c || E] = le(f));
    }
    const i = (f, E) => u.forEach(f, (a, b) => s(a, b, E));
    return u.isPlainObject(t) || t instanceof this.constructor ? i(t, r) : u.isString(t) && (t = t.trim()) && !sn(t) ? i(nn(t), r) : t != null && s(r, t, n), this;
  }
  get(t, r) {
    if (t = J(t), t) {
      const n = u.findKey(this, t);
      if (n) {
        const o = this[n];
        if (!r)
          return o;
        if (r === !0)
          return on(o);
        if (u.isFunction(r))
          return r.call(this, o, n);
        if (u.isRegExp(r))
          return r.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, r) {
    if (t = J(t), t) {
      const n = u.findKey(this, t);
      return !!(n && this[n] !== void 0 && (!r || ve(this, this[n], n, r)));
    }
    return !1;
  }
  delete(t, r) {
    const n = this;
    let o = !1;
    function s(i) {
      if (i = J(i), i) {
        const f = u.findKey(n, i);
        f && (!r || ve(n, n[f], f, r)) && (delete n[f], o = !0);
      }
    }
    return u.isArray(t) ? t.forEach(s) : s(t), o;
  }
  clear(t) {
    const r = Object.keys(this);
    let n = r.length, o = !1;
    for (; n--; ) {
      const s = r[n];
      (!t || ve(this, this[s], s, t, !0)) && (delete this[s], o = !0);
    }
    return o;
  }
  normalize(t) {
    const r = this, n = {};
    return u.forEach(this, (o, s) => {
      const i = u.findKey(n, s);
      if (i) {
        r[i] = le(o), delete r[s];
        return;
      }
      const f = t ? an(s) : String(s).trim();
      f !== s && delete r[s], r[f] = le(o), n[f] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const r = /* @__PURE__ */ Object.create(null);
    return u.forEach(this, (n, o) => {
      n != null && n !== !1 && (r[o] = t && u.isArray(n) ? n.join(", ") : n);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, r]) => t + ": " + r).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...r) {
    const n = new this(t);
    return r.forEach((o) => n.set(o)), n;
  }
  static accessor(t) {
    const n = (this[Je] = this[Je] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function s(i) {
      const f = J(i);
      n[f] || (un(o, i), n[f] = !0);
    }
    return u.isArray(t) ? t.forEach(s) : s(t), this;
  }
}
we.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
u.reduceDescriptors(we.prototype, ({ value: e }, t) => {
  let r = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(n) {
      this[r] = n;
    }
  };
});
u.freezeMethods(we);
const I = we;
function Se(e, t) {
  const r = this || Pe, n = t || r, o = I.from(n.headers);
  let s = n.data;
  return u.forEach(e, function(f) {
    s = f.call(r, s, o.normalize(), t ? t.status : void 0);
  }), o.normalize(), s;
}
function xt(e) {
  return !!(e && e.__CANCEL__);
}
function Z(e, t, r) {
  x.call(this, e == null ? "canceled" : e, x.ERR_CANCELED, t, r), this.name = "CanceledError";
}
u.inherits(Z, x, {
  __CANCEL__: !0
});
function cn(e, t, r) {
  const n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? e(r) : t(new x(
    "Request failed with status code " + r.status,
    [x.ERR_BAD_REQUEST, x.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
const ln = L.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, r, n, o, s) {
      const i = [e + "=" + encodeURIComponent(t)];
      u.isNumber(r) && i.push("expires=" + new Date(r).toGMTString()), u.isString(n) && i.push("path=" + n), u.isString(o) && i.push("domain=" + o), s === !0 && i.push("secure"), document.cookie = i.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function fn(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function dn(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Ct(e, t) {
  return e && !fn(t) ? dn(e, t) : t;
}
const hn = L.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = /(msie|trident)/i.test(navigator.userAgent), r = document.createElement("a");
    let n;
    function o(s) {
      let i = s;
      return t && (r.setAttribute("href", i), i = r.href), r.setAttribute("href", i), {
        href: r.href,
        protocol: r.protocol ? r.protocol.replace(/:$/, "") : "",
        host: r.host,
        search: r.search ? r.search.replace(/^\?/, "") : "",
        hash: r.hash ? r.hash.replace(/^#/, "") : "",
        hostname: r.hostname,
        port: r.port,
        pathname: r.pathname.charAt(0) === "/" ? r.pathname : "/" + r.pathname
      };
    }
    return n = o(window.location.href), function(i) {
      const f = u.isString(i) ? o(i) : i;
      return f.protocol === n.protocol && f.host === n.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  function() {
    return function() {
      return !0;
    };
  }()
);
function pn(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function mn(e, t) {
  e = e || 10;
  const r = new Array(e), n = new Array(e);
  let o = 0, s = 0, i;
  return t = t !== void 0 ? t : 1e3, function(E) {
    const a = Date.now(), b = n[s];
    i || (i = a), r[o] = E, n[o] = a;
    let c = s, O = 0;
    for (; c !== o; )
      O += r[c++], c = c % e;
    if (o = (o + 1) % e, o === s && (s = (s + 1) % e), a - i < t)
      return;
    const T = b && a - b;
    return T ? Math.round(O * 1e3 / T) : void 0;
  };
}
function Ke(e, t) {
  let r = 0;
  const n = mn(50, 250);
  return (o) => {
    const s = o.loaded, i = o.lengthComputable ? o.total : void 0, f = s - r, E = n(f), a = s <= i;
    r = s;
    const b = {
      loaded: s,
      total: i,
      progress: i ? s / i : void 0,
      bytes: f,
      rate: E || void 0,
      estimated: E && i && a ? (i - s) / E : void 0,
      event: o
    };
    b[t ? "download" : "upload"] = !0, e(b);
  };
}
const yn = typeof XMLHttpRequest != "undefined", gn = yn && function(e) {
  return new Promise(function(r, n) {
    let o = e.data;
    const s = I.from(e.headers).normalize();
    let { responseType: i, withXSRFToken: f } = e, E;
    function a() {
      e.cancelToken && e.cancelToken.unsubscribe(E), e.signal && e.signal.removeEventListener("abort", E);
    }
    let b;
    if (u.isFormData(o)) {
      if (L.hasStandardBrowserEnv || L.hasStandardBrowserWebWorkerEnv)
        s.setContentType(!1);
      else if ((b = s.getContentType()) !== !1) {
        const [d, ...S] = b ? b.split(";").map((C) => C.trim()).filter(Boolean) : [];
        s.setContentType([d || "multipart/form-data", ...S].join("; "));
      }
    }
    let c = new XMLHttpRequest();
    if (e.auth) {
      const d = e.auth.username || "", S = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
      s.set("Authorization", "Basic " + btoa(d + ":" + S));
    }
    const O = Ct(e.baseURL, e.url);
    c.open(e.method.toUpperCase(), St(O, e.params, e.paramsSerializer), !0), c.timeout = e.timeout;
    function T() {
      if (!c)
        return;
      const d = I.from(
        "getAllResponseHeaders" in c && c.getAllResponseHeaders()
      ), C = {
        data: !i || i === "text" || i === "json" ? c.responseText : c.response,
        status: c.status,
        statusText: c.statusText,
        headers: d,
        config: e,
        request: c
      };
      cn(function(g) {
        r(g), a();
      }, function(g) {
        n(g), a();
      }, C), c = null;
    }
    if ("onloadend" in c ? c.onloadend = T : c.onreadystatechange = function() {
      !c || c.readyState !== 4 || c.status === 0 && !(c.responseURL && c.responseURL.indexOf("file:") === 0) || setTimeout(T);
    }, c.onabort = function() {
      c && (n(new x("Request aborted", x.ECONNABORTED, e, c)), c = null);
    }, c.onerror = function() {
      n(new x("Network Error", x.ERR_NETWORK, e, c)), c = null;
    }, c.ontimeout = function() {
      let S = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded";
      const C = e.transitional || Rt;
      e.timeoutErrorMessage && (S = e.timeoutErrorMessage), n(new x(
        S,
        C.clarifyTimeoutError ? x.ETIMEDOUT : x.ECONNABORTED,
        e,
        c
      )), c = null;
    }, L.hasStandardBrowserEnv && (f && u.isFunction(f) && (f = f(e)), f || f !== !1 && hn(O))) {
      const d = e.xsrfHeaderName && e.xsrfCookieName && ln.read(e.xsrfCookieName);
      d && s.set(e.xsrfHeaderName, d);
    }
    o === void 0 && s.setContentType(null), "setRequestHeader" in c && u.forEach(s.toJSON(), function(S, C) {
      c.setRequestHeader(C, S);
    }), u.isUndefined(e.withCredentials) || (c.withCredentials = !!e.withCredentials), i && i !== "json" && (c.responseType = e.responseType), typeof e.onDownloadProgress == "function" && c.addEventListener("progress", Ke(e.onDownloadProgress, !0)), typeof e.onUploadProgress == "function" && c.upload && c.upload.addEventListener("progress", Ke(e.onUploadProgress)), (e.cancelToken || e.signal) && (E = (d) => {
      c && (n(!d || d.type ? new Z(null, e, c) : d), c.abort(), c = null);
    }, e.cancelToken && e.cancelToken.subscribe(E), e.signal && (e.signal.aborted ? E() : e.signal.addEventListener("abort", E)));
    const w = pn(O);
    if (w && L.protocols.indexOf(w) === -1) {
      n(new x("Unsupported protocol " + w + ":", x.ERR_BAD_REQUEST, e));
      return;
    }
    c.send(o || null);
  });
}, xe = {
  http: Hr,
  xhr: gn
};
u.forEach(xe, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch (r) {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Ge = (e) => `- ${e}`, wn = (e) => u.isFunction(e) || e === null || e === !1, Tt = {
  getAdapter: (e) => {
    e = u.isArray(e) ? e : [e];
    const { length: t } = e;
    let r, n;
    const o = {};
    for (let s = 0; s < t; s++) {
      r = e[s];
      let i;
      if (n = r, !wn(r) && (n = xe[(i = String(r)).toLowerCase()], n === void 0))
        throw new x(`Unknown adapter '${i}'`);
      if (n)
        break;
      o[i || "#" + s] = n;
    }
    if (!n) {
      const s = Object.entries(o).map(
        ([f, E]) => `adapter ${f} ` + (E === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let i = t ? s.length > 1 ? `since :
` + s.map(Ge).join(`
`) : " " + Ge(s[0]) : "as no adapter specified";
      throw new x(
        "There is no suitable adapter to dispatch the request " + i,
        "ERR_NOT_SUPPORT"
      );
    }
    return n;
  },
  adapters: xe
};
function Re(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Z(null, e);
}
function Xe(e) {
  return Re(e), e.headers = I.from(e.headers), e.data = Se.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Tt.getAdapter(e.adapter || Pe.adapter)(e).then(function(n) {
    return Re(e), n.data = Se.call(
      e,
      e.transformResponse,
      n
    ), n.headers = I.from(n.headers), n;
  }, function(n) {
    return xt(n) || (Re(e), n && n.response && (n.response.data = Se.call(
      e,
      e.transformResponse,
      n.response
    ), n.response.headers = I.from(n.response.headers))), Promise.reject(n);
  });
}
const Qe = (e) => e instanceof I ? ae({}, e) : e;
function z(e, t) {
  t = t || {};
  const r = {};
  function n(a, b, c) {
    return u.isPlainObject(a) && u.isPlainObject(b) ? u.merge.call({ caseless: c }, a, b) : u.isPlainObject(b) ? u.merge({}, b) : u.isArray(b) ? b.slice() : b;
  }
  function o(a, b, c) {
    if (u.isUndefined(b)) {
      if (!u.isUndefined(a))
        return n(void 0, a, c);
    } else
      return n(a, b, c);
  }
  function s(a, b) {
    if (!u.isUndefined(b))
      return n(void 0, b);
  }
  function i(a, b) {
    if (u.isUndefined(b)) {
      if (!u.isUndefined(a))
        return n(void 0, a);
    } else
      return n(void 0, b);
  }
  function f(a, b, c) {
    if (c in t)
      return n(a, b);
    if (c in e)
      return n(void 0, a);
  }
  const E = {
    url: s,
    method: s,
    data: s,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    withXSRFToken: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: f,
    headers: (a, b) => o(Qe(a), Qe(b), !0)
  };
  return u.forEach(Object.keys(Object.assign({}, e, t)), function(b) {
    const c = E[b] || o, O = c(e[b], t[b], b);
    u.isUndefined(O) && c !== f || (r[b] = O);
  }), r;
}
const _t = "1.6.8", ke = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  ke[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Ze = {};
ke.transitional = function(t, r, n) {
  function o(s, i) {
    return "[Axios v" + _t + "] Transitional option '" + s + "'" + i + (n ? ". " + n : "");
  }
  return (s, i, f) => {
    if (t === !1)
      throw new x(
        o(i, " has been removed" + (r ? " in " + r : "")),
        x.ERR_DEPRECATED
      );
    return r && !Ze[i] && (Ze[i] = !0, console.warn(
      o(
        i,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), t ? t(s, i, f) : !0;
  };
};
function bn(e, t, r) {
  if (typeof e != "object")
    throw new x("options must be an object", x.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(e);
  let o = n.length;
  for (; o-- > 0; ) {
    const s = n[o], i = t[s];
    if (i) {
      const f = e[s], E = f === void 0 || i(f, s, e);
      if (E !== !0)
        throw new x("option " + s + " must be " + E, x.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new x("Unknown option " + s, x.ERR_BAD_OPTION);
  }
}
const Ce = {
  assertOptions: bn,
  validators: ke
}, H = Ce.validators;
class he {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new We(),
      response: new We()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(t, r) {
    return $(this, null, function* () {
      try {
        return yield this._request(t, r);
      } catch (n) {
        if (n instanceof Error) {
          let o;
          Error.captureStackTrace ? Error.captureStackTrace(o = {}) : o = new Error();
          const s = o.stack ? o.stack.replace(/^.+\n/, "") : "";
          n.stack ? s && !String(n.stack).endsWith(s.replace(/^.+\n.+\n/, "")) && (n.stack += `
` + s) : n.stack = s;
        }
        throw n;
      }
    });
  }
  _request(t, r) {
    typeof t == "string" ? (r = r || {}, r.url = t) : r = t || {}, r = z(this.defaults, r);
    const { transitional: n, paramsSerializer: o, headers: s } = r;
    n !== void 0 && Ce.assertOptions(n, {
      silentJSONParsing: H.transitional(H.boolean),
      forcedJSONParsing: H.transitional(H.boolean),
      clarifyTimeoutError: H.transitional(H.boolean)
    }, !1), o != null && (u.isFunction(o) ? r.paramsSerializer = {
      serialize: o
    } : Ce.assertOptions(o, {
      encode: H.function,
      serialize: H.function
    }, !0)), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let i = s && u.merge(
      s.common,
      s[r.method]
    );
    s && u.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (w) => {
        delete s[w];
      }
    ), r.headers = I.concat(i, s);
    const f = [];
    let E = !0;
    this.interceptors.request.forEach(function(d) {
      typeof d.runWhen == "function" && d.runWhen(r) === !1 || (E = E && d.synchronous, f.unshift(d.fulfilled, d.rejected));
    });
    const a = [];
    this.interceptors.response.forEach(function(d) {
      a.push(d.fulfilled, d.rejected);
    });
    let b, c = 0, O;
    if (!E) {
      const w = [Xe.bind(this), void 0];
      for (w.unshift.apply(w, f), w.push.apply(w, a), O = w.length, b = Promise.resolve(r); c < O; )
        b = b.then(w[c++], w[c++]);
      return b;
    }
    O = f.length;
    let T = r;
    for (c = 0; c < O; ) {
      const w = f[c++], d = f[c++];
      try {
        T = w(T);
      } catch (S) {
        d.call(this, S);
        break;
      }
    }
    try {
      b = Xe.call(this, T);
    } catch (w) {
      return Promise.reject(w);
    }
    for (c = 0, O = a.length; c < O; )
      b = b.then(a[c++], a[c++]);
    return b;
  }
  getUri(t) {
    t = z(this.defaults, t);
    const r = Ct(t.baseURL, t.url);
    return St(r, t.params, t.paramsSerializer);
  }
}
u.forEach(["delete", "get", "head", "options"], function(t) {
  he.prototype[t] = function(r, n) {
    return this.request(z(n || {}, {
      method: t,
      url: r,
      data: (n || {}).data
    }));
  };
});
u.forEach(["post", "put", "patch"], function(t) {
  function r(n) {
    return function(s, i, f) {
      return this.request(z(f || {}, {
        method: t,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: s,
        data: i
      }));
    };
  }
  he.prototype[t] = r(), he.prototype[t + "Form"] = r(!0);
});
const fe = he;
class Le {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(s) {
      r = s;
    });
    const n = this;
    this.promise.then((o) => {
      if (!n._listeners)
        return;
      let s = n._listeners.length;
      for (; s-- > 0; )
        n._listeners[s](o);
      n._listeners = null;
    }), this.promise.then = (o) => {
      let s;
      const i = new Promise((f) => {
        n.subscribe(f), s = f;
      }).then(o);
      return i.cancel = function() {
        n.unsubscribe(s);
      }, i;
    }, t(function(s, i, f) {
      n.reason || (n.reason = new Z(s, i, f), r(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(t);
    r !== -1 && this._listeners.splice(r, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Le(function(o) {
        t = o;
      }),
      cancel: t
    };
  }
}
const En = Le;
function vn(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function Sn(e) {
  return u.isObject(e) && e.isAxiosError === !0;
}
const Te = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Te).forEach(([e, t]) => {
  Te[t] = e;
});
const Rn = Te;
function Bt(e) {
  const t = new fe(e), r = lt(fe.prototype.request, t);
  return u.extend(r, fe.prototype, t, { allOwnKeys: !0 }), u.extend(r, t, null, { allOwnKeys: !0 }), r.create = function(o) {
    return Bt(z(e, o));
  }, r;
}
const B = Bt(Pe);
B.Axios = fe;
B.CanceledError = Z;
B.CancelToken = En;
B.isCancel = xt;
B.VERSION = _t;
B.toFormData = ge;
B.AxiosError = x;
B.Cancel = B.CanceledError;
B.all = function(t) {
  return Promise.all(t);
};
B.spread = vn;
B.isAxiosError = Sn;
B.mergeConfig = z;
B.AxiosHeaders = I;
B.formToJSON = (e) => At(u.isHTMLForm(e) ? new FormData(e) : e);
B.getAdapter = Tt.getAdapter;
B.HttpStatusCode = Rn;
B.default = B;
const On = B, An = (e, t, r) => {
  const n = r && r.mode && typeof r.mode == "function" && r.mode() === _e.Disabled;
  return !!(e && t && t.experimentKey && t.experimentVariant && !n);
}, Ye = (e) => Ue(e) === "string", et = (e) => Ue(e) === "boolean", tt = (e) => Ue(e) === "number" && Number.isSafeInteger(e), Ue = (e) => {
  const t = typeof e;
  if (t !== "object")
    return t;
  const r = (s) => s[0].toLowerCase() + s.slice(1), n = Object.prototype.toString.call(e).replace(/^\[object (\S+)\]$/, "$1");
  return r(n);
}, xn = "x-amz-version-id";
let rt;
class Cn {
  constructor() {
    this.featureLookup = {}, this.configCreatedAt = "", this.versionId = "";
  }
  fetchAndUpdate(t, r, n = () => {
  }) {
    return $(this, null, function* () {
      const o = yield r.get(t), s = o == null ? void 0 : o.headers;
      return s && (this.versionId = s[xn]), this.init(o.data, n), o.data;
    });
  }
  loadFromCdn(t, r, n) {
    return $(this, null, function* () {
      const o = this.buildUrl(t), s = yield this.fetchAndUpdate(o, r, n);
      if (clearInterval(rt), t.poll) {
        const i = t.pollInterval || 3e4;
        rt = setInterval(() => {
          this.fetchAndUpdate(o, r, n);
        }, i);
      }
      return s;
    });
  }
  init(t, r = () => {
  }) {
    const n = typeof t == "string" ? JSON.parse(t) : t;
    this.configCreatedAt >= n.createdAt || (this.configCreatedAt = n.createdAt, this.configCreatedAt && (k.logInfo(`Loading new feature config - created at: ${this.configCreatedAt}`), this.featureLookup = {}, n.features.forEach((o) => {
      this.featureLookup[o.key] = o;
    }), r()));
  }
  getFeature(t) {
    return this.featureLookup[t];
  }
  getFeatureKeys() {
    return this.featureLookup;
  }
  getFeatureKeysByTags(t = []) {
    if (t.length == 0)
      return this.getFeatureKeys();
    const n = Object.values(this.featureLookup).filter(
      (s) => s.tags && s.tags.some((i) => t.includes(i))
    ), o = {};
    return n.forEach((s) => {
      o[s.key] = s;
    }), o;
  }
  getFilteredConfigByTags(t = []) {
    let r = Object.values(this.featureLookup);
    t.length > 0 && (r = r.filter(
      (o) => o.tags && o.tags.some((s) => t.includes(s))
    ));
    const n = this.configCreatedAt;
    return { features: r, createdAt: n };
  }
  getVersionId() {
    return this.versionId;
  }
  buildUrl(t) {
    const r = t.host || "https://features.api.justeattakeaway.com", n = t.key ? `-${t.key}` : "", o = this.isNullOrWhiteSpace(t.versionId) ? "" : `?versionId=${t.versionId}`;
    return `${r}/config/v1/${t.scope}/${t.environment}${n}${o}`;
  }
  isNullOrWhiteSpace(t) {
    return t == null || t.trim() === "";
  }
}
const q = (e, t, r) => {
  k.logInfo(`${e.name}: ${t} => ${r}`);
};
class Tn {
  constructor(t, r) {
    var n;
    if (this.settings = t, r)
      this.httpClient = r;
    else {
      let o = {};
      (n = t.cdn) != null && n.poll && (o = {
        headers: {
          "cache-control": "no-cache"
        }
      }), this.httpClient = On.create(o);
    }
    this.getContext = t.getContext, this.onTrack = t.onTrack, this.observer = new or(this), this.override = t.urlString ? new sr(t.urlString) : null, this.featureLookup = new Cn(), this.settings.initialConfigAsJson && this.featureLookup.init(this.settings.initialConfigAsJson);
  }
  getQualifiedKey(t) {
    if (t.includes("::"))
      return t;
    const { keyPrefix: r } = this.settings;
    return r ? `${r}::${t}` : t;
  }
  getValue(t, r = [], n = !0) {
    try {
      const o = this.featureLookup.getFeature(this.getQualifiedKey(t));
      if (r.length > 0 && o.tags && !o.tags.some((b) => r.includes(b)))
        return null;
      const i = o && o.valueType || null, f = this.override ? this.override.getOverride(t, i) : null;
      if (f !== null)
        return f;
      if (!o)
        return null;
      const E = this.getContext();
      if (!E)
        return k.logError(
          "Unable to provide feature values as no context was provided. Check your settings for the plugin"
        ), null;
      const a = tr(o, E);
      return a ? (An(n, a, E) && nr(a, this.onTrack), a.value) : rr(o, E);
    } catch (o) {
      const s = o instanceof Error ? o.message : "Unknown error";
      k.logError(s, { error: o });
    }
    return null;
  }
  getCompositeStringValue(t, r, n = []) {
    const o = this.getValue(t, n);
    if (o === null || !r)
      return null;
    const s = o[r];
    return Ye(s) ? (q(this.getStringValue, t, s), s) : null;
  }
  getCompositeBoolValue(t, r, n = []) {
    const o = this.getValue(t, n);
    if (o === null || !r)
      return null;
    const s = o[r];
    return et(s) ? (q(this.getBooleanValue, t, s), !!s) : null;
  }
  getCompositeIntValue(t, r, n = []) {
    const o = this.getValue(t, n);
    if (o === null || !r)
      return null;
    const s = o[r];
    return tt(s) ? (q(this.getIntegerValue, t, s), Number(s)) : null;
  }
  getBooleanValue(t, r = []) {
    const n = this.getValue(t, r);
    return n === null ? null : et(n) ? (q(this.getBooleanValue, t, n), !!n) : null;
  }
  getIntegerValue(t, r = []) {
    const n = this.getValue(t, r);
    return n == null ? null : tt(n) ? (q(this.getIntegerValue, t, n), Number(n)) : null;
  }
  getStringValue(t, r = []) {
    const n = this.getValue(t, r);
    return n === null ? null : Ye(n) ? (q(this.getStringValue, t, n), `${n}`) : null;
  }
  loadFromCdn() {
    return $(this, null, function* () {
      return this.loadConfigFromCdn();
    });
  }
  loadFromCdnWithVersionId() {
    return $(this, null, function* () {
      const t = yield this.loadConfigFromCdn(), r = this.featureLookup.getVersionId();
      return { config: t, versionId: r };
    });
  }
  loadConfigFromCdn() {
    return $(this, null, function* () {
      if (!this.settings.cdn)
        throw new Error("CDN settings were not provided.");
      return this.featureLookup.loadFromCdn(
        this.settings.cdn,
        this.httpClient,
        this.settings.onUpdated
      );
    });
  }
  updateConfig(t) {
    this.featureLookup.init(t);
  }
}
const Bn = (e, t) => (e.logger && e.logger && Lt(e.logger), e.getContext || (e.getContext = kt), new Tn(e, t));
export {
  Bn as createFeatureManager
};
